export type DailyAttendanceReportStateType = {
  params: any;
  data: {
    loading: boolean;
    workers: {
      loading: boolean;
      fetched: boolean;
      data: any;
    };
    siteId: {
      fetched: boolean;
      projectID: string;
    };
  };
};

export const initialState: DailyAttendanceReportStateType = {
  params: {},
  data: {
    loading: false,
    workers: {
      loading: false,
      fetched: false,
      data: {},
    },
    siteId: {
      fetched: false,
      projectID: '',
    },
  },
};
